module.exports = __webpack_public_path__ + "static/media/ticket.d79734f2.svg";